module.exports = __webpack_public_path__ + "static/media/Sachman.31eac824.mp4";